import { render, staticRenderFns } from "./floor-style-ermei-design-1.vue?vue&type=template&id=8984f946"
import script from "./floor-style-ermei-design-1.vue?vue&type=script&lang=js"
export * from "./floor-style-ermei-design-1.vue?vue&type=script&lang=js"
import style0 from "./floor-style-ermei-design-1.vue?vue&type=style&index=0&id=8984f946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports